import React, { Component } from 'react';
import './feedback.css';
import FeedbackTitlePage from './feedbackTitle/feedbackTitle.js';
import FeedbackList from './feedbackList/feedbackList.js';
import HighlightedFeedback from './highlightedFeedback/highlightedFeedback.js';
import downloadFeedback from './utils/downloadFeedback.js';

class Feedback extends Component {

  state = {
    feedback: [],
    highlightedFeedback: ''
  }

  componentDidMount() {

    setTimeout(this.handleDownloadingFeedback, 0);

  }

  render() {

    return (
      <div className="FeedbackPage">
        <FeedbackTitlePage handleDownloadingFeedback={this.handleDownloadingFeedback}/>
        <div className="FeedbackDisplay">
          <FeedbackList feedback={this.state.feedback} updateFeedbackState={this.updateFeedbackState}/>
          <div className="FeedbackHighlightView">
            {this.state.highlightedFeedback && <HighlightedFeedback feedback={this.state.feedback.find(feedback => feedback.id === this.state.highlightedFeedback)} handleDownloadingFeedback={this.handleDownloadingFeedback}/>}
          </div>
        </div>
      </div>
    );
  }

    updateFeedbackState = object => {
      this.setState(object);
    }

    handleDownloadingFeedback = () => {
      downloadFeedback()
      .then(feedback => {
        this.setState({feedback});
      });
    }

}

export default Feedback;


// WEBPACK FOOTER //
// ./src/components/content/feedback/feedback.js